import marshallheadbg from '../../assets/marshall/headphones/marshall-headphone-bg.jpg';

import { useSelector, useDispatch } from 'react-redux';
import { setSelectedProduct } from '../../redux/productSlice';
import { useNavigate } from 'react-router-dom';

function MarshallHeadphones() {
  const headphones = useSelector((state) => state.products.headphones);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  return (
    <div className="marshall-headphone-section">
      {/* HEADPHONE HEADER */}
      <div
        className="headphone-head-bg"
        style={{
          backgroundImage: `URL(${marshallheadbg})`,
        }}
      >
        <p className="headphone-header">HEADPHONES</p>
      </div>

      {/* HEADPHONE PRODUCT  */}
      <section class="catalog">
        <div className="product-cate">
          <div class="product-grid">
            {/* <!-- Row 1 --> */}
            {headphones
              .filter((headphone) => headphone.category === 'headphone')
              .map((headphone) => (
                <div class="headphone-item">
                  <img
                    src={headphone.picture}
                    alt="MINOR III"
                    onClick={() => {
                      dispatch(setSelectedProduct(headphone));
                      navigate(
                        `/marshall/details/${headphone.type}/${headphone.id}`
                      );
                    }}
                  />
                  <span
                    onClick={() => {
                      dispatch(setSelectedProduct(headphone));
                      navigate(
                        `/marshall/details/${headphone.type}/${headphone.id}`
                      );
                    }}
                  >
                    {headphone.productName}
                  </span>
                </div>
              ))}
          </div>

          {/* <!-- Row 2 --> */}
          <div className="product-grid">
            {headphones
              .filter((onearpod) => onearpod.category === 'onearpod')
              .map((onearpod) => (
                <div class="headphone-item">
                  <img
                    src={onearpod.picture}
                    alt="MID A.N.C."
                    onClick={() => {
                      dispatch(setSelectedProduct(onearpod));
                      navigate(
                        `/marshall/details/${onearpod.type}/${onearpod.id}`
                      );
                    }}
                  />
                  <span
                    onClick={() => {
                      dispatch(setSelectedProduct(onearpod));
                      navigate(
                        `/marshall/details/${onearpod.type}/${onearpod.id}`
                      );
                    }}
                  >
                    {onearpod.productName}
                  </span>
                </div>
              ))}
          </div>

          {/* <!-- Row 3 --> */}
          <div className="product-grid">
            {headphones
              .filter((onear) => onear.category === 'onear')
              .map((onear) => (
                <div class="headphone-item">
                  <img
                    src={onear.picture}
                    alt="MONITOR"
                    onClick={() => {
                      dispatch(setSelectedProduct(onear));
                      navigate(`/marshall/details/${onear.type}/${onear.id}`);
                    }}
                  />
                  <span
                    onClick={() => {
                      dispatch(setSelectedProduct(onear));
                      navigate(`/marshall/details/${onear.type}/${onear.id}`);
                    }}
                  >
                    {onear.productName}
                  </span>
                </div>
              ))}
          </div>
        </div>

        <div className="catalog-head">
          <h1>HEADPHONES</h1>
          <p>
            FROM IN-EARS TO OVER-EARS AND <br />
            EVERYTHING IN-BETWEEN, THERE’S A MARSHALL <br />
            HEADPHONE THAT’S PERFECT FOR YOU.
          </p>
        </div>
      </section>
    </div>
  );
}

export default MarshallHeadphones;
